export default __webpack_public_path__ + "static/media/get-access-msg.3fd0e3be.svg";